import {createAction, handleActions} from 'redux-actions';

const SET_CATEGORY = 'category/SET_CATEGORY';
export const setCategory = createAction(SET_CATEGORY);

let initialState = {
	param: {
    "disp_yn": "Y",
    "del_yn": "N"
	},
	category: [],
}

export default handleActions({
	[SET_CATEGORY]: (state, action) => {
		action.payload = action.payload ? action.payload : {}

		return {
			...state,
			param: {
				...state.param,
				disp_yn: action.payload.param && action.payload.param.disp_yn ? action.payload.param.disp_yn : state.param.disp_yn,
				del_yn: action.payload.param && action.payload.param.del_yn ? action.payload.param.del_yn : state.param.del_yn,
			},
      category: action.payload.category ? action.payload.category : state.category,
		}
	},
}, initialState)